import {
  END_EMAIL_GROUP,
  START_EMAIL_GROUP,
} from '../actions/requirements_set';

export default function(state = {}, action) {
  switch (action.type) {
  case END_EMAIL_GROUP:
    return {
      ...state,
      emailGroup: null
    };
  case START_EMAIL_GROUP:
    return {
      ...state,
      emailGroup: action.emails
    };
  }
  return { ...state };
}
